export default __webpack_public_path__ + "static/media/economy.61e4a774.svg";